<template>
  <div>
    <div id="service-wrap" class="service-wrap">
      <div class="row">
        <div
          v-for="(category, index) in categories.categories"
          :key="category.id"
          class="col-12"
        >
          <badger-accordion
            :key="category.id"
            :icons="icons"
            class="data-block-list-item data-block-list-item-accordion"
            refs="myAccordion"
          >
            <template v-if="Object.keys(category.services).length != 0">
              <badger-accordion-item>
                <template slot="header">
                  <div class="header-title">
                    <span class="value-title"> {{ category.name }} </span>
                  </div>
                </template>
                <template slot="content" class="data-block-item-content">
                  <div
                    v-if="Object.keys(category.services).length != 0"
                    class="data-block-item-content-wrap"
                  >
                    <div v-for="service in category.services" :key="service.id">
                      <div class="form-group row">
                        <div class="col-md-12">
                          <a :href="`${service.service_url}`">
                            {{ service.name }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="data-block-item-content-wrap">
                    <div
                      class="data-block-item-content-wrap-content"
                      v-html="category.content[`${$app.lang}`]"
                    ></div>
                  </div>
                </template>
              </badger-accordion-item>
            </template>
            <template v-else>
              <dt class="badger-accordion__header">
                <div class="js-badger-accordion-header" aria-expanded="false">
                  <button class="badger-accordion-toggle">
                    <span class="badger-accordion-title">
                      <div class="header-title">
                        <span class="value-title">
                          {{ category.name }}
                        </span>
                      </div>
                    </span>
                  </button>
                </div>
              </dt>
            </template>
          </badger-accordion>
        </div>
      </div>
    </div>

    <services-filters> </services-filters>
    <div
      v-show="!showFilters"
      class="show-filters"
      @click="toggleShowFilters()"
    ></div>
  </div>
</template>

<script>
import { BadgerAccordion, BadgerAccordionItem } from 'vue-badger-accordion'
import 'badger-accordion/dist/badger-accordion.css'
// Ensure badger-accordion library is bundled
import 'badger-accordion'

export default {
  name: 'Services',
  title: '',
  components: {
    BadgerAccordion,
    BadgerAccordionItem,
  },
  props: {},
  data() {
    return {
      urlPath: '/map',
      selected: [],
      window: {
        width: 0,
        height: 0,
      },
      icons: {
        opened: '<i class="fas fa-chevron-up"></i>',
        closed: '<i class="fas fa-chevron-down"></i>',
      },
    }
  },
  computed: {
    model() {
      return this.$store.getters['services/data']
    },
    services() {
      return this.$store.getters['services/getServices']
    },
    categories() {
      return this.$store.getters['services/getCategories']
    },
    showFilters() {
      return this.$store.getters['services/getShowFilters']
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  mounted() {
    //this.setLoc()
    this.$store.dispatch('services/getCategories', {})
    //this.$store.dispatch('services/getServices', {})
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight - 50
    },
    toggleShowFilters() {
      //this.$store.dispatch('services/toggleShowFilters', {
      //showFilters: !this.showFilters
      //})
    },
  },
}
</script>
